import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import Icon from 'components/Icon';

// New design props
// @text: string | inner text
// @children: childer | inner content
// @icon: string | inner icon
// @theme: string | theme's color
// @outline: boolean | is it outlined on filled?
// @small: boolean | is it small?
// @block: boolean | is it full-width?
// @link: string | url
// @submit: boolean | is it form's submit button?
// @onClick: function | onClick handler
const Button = ({
	text,
	children,
	icon,
	theme,
	outline,
	small,
	block,
	active,
	square,
	space,
	animation,
	submit,
	link,
	className,
	onClick
}) => {
	const cls = useMemo(() => classnames(
		'button',
		icon && 'button--icon',
		theme && `button--${theme}`,
		outline && 'button--outline',
		small && 'button--small',
		block && 'button--block',
		active && 'button--active',
		square && 'button--square',
		space && 'button--space',
		animation && 'button--animation',
		className
	), [icon, theme, outline, small, block, active, square, space, animation, className]);

	if (link) {
		return (
			<Link to={link} className={cls}>
				{icon && <Icon icon={icon} size={small ? 'sm' : 'md'} />}
				{text}
				{children}
			</Link>
		);
	} else {
		return (
			<button type={submit ? 'submit' : 'button'} onClick={onClick} className={cls}>
				{icon && <Icon icon={icon} size={small ? 'sm' : 'md'} />}
				{text}
				{children}
			</button>
		);
	}
};

export default Button;
